import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { QuickViewEventDTO } from 'src/app/models/quickview/quick-view-event-dto'
import { SlatAssessmentTableGroupByDto } from 'src/app/models/slat/slat-assessment-table-group-dto'
import { SlatAssessmentTableItemsDto } from 'src/app/models/slat/slat-assessment-table-items-dto'
@Component({
  selector: 'app-table-multi-header',
  templateUrl: './table-multi-header.component.html',
  styleUrls: ['./table-multi-header.component.scss'],
  standalone: false,
})
export class TableMultiHeaderComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() dataSource: (
    | SlatAssessmentTableItemsDto
    | SlatAssessmentTableGroupByDto
  )[] = [] //: MatTableDataSource<any> = new MatTableDataSource<any>()
  @Input() isEdit: boolean = false
  @Input() isView: boolean = false
  @Input() isAdd: boolean = false
  @Input() isTableHeaderVisible: boolean = false

  @Output() rowClick = new EventEmitter<QuickViewEventDTO>()
  @Output() addClick = new EventEmitter<{ element: any; index: number }>()
  @Output() editClick = new EventEmitter<{ element: any; index: number }>()

  displayedColumns: string[] = [
    'Name',
    'RawScore',
    'Score',
    'PercentileRank',
    'Level',
    'Action',
  ]
  displayedColumnsView: string[] = [
    'Name',
    'RawScore',
    'Score',
    'PercentileRank',
    'Level',
  ]

  displayedHeaders: string[] = [
    'GroupName',
    'HeadingColumn1',
    'HeadingColumn2',
    'HeadingColumn3',
    'HeadingColumn4',
    'HeadingColumn5',
  ]
  displayedHeadersView: string[] = [
    'GroupName',
    'HeadingColumn1',
    'HeadingColumn2',
    'HeadingColumn3',
    'HeadingColumn4',
  ]

  ngOnInit(): void {
    this.displayedColumns = this.isView
      ? this.displayedColumnsView
      : this.displayedColumns
    this.displayedHeaders = this.isView
      ? this.displayedHeadersView
      : this.displayedHeaders
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngAfterViewInit(): void {}

  onRowClicked(row: QuickViewEventDTO): void {
    this.rowClick.emit(row)
  }

  onEditClick($event: any, element: any, index: number): void {
    this.editClick.emit({ element, index })
  }

  onAddClick($event: any, element: any, index: number): void {
    this.addClick.emit({ element, index })
  }

  isRegularRow = (
    index: number,
    row: SlatAssessmentTableItemsDto | SlatAssessmentTableGroupByDto,
  ) => !row.isGroupBy
  isGroup = (
    index: number,
    row: SlatAssessmentTableItemsDto | SlatAssessmentTableGroupByDto,
  ) => row.isGroupBy
}
